import { createContext, useContext, useEffect, useState } from 'react';

export const TIPS_STORAGE_KEY = 'slashRoll.corebound.tips.v1';
const HelpContext = createContext(null);

const readPreferences = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(TIPS_STORAGE_KEY));
    if (
      saved &&
      typeof saved.enabled === 'boolean' &&
      Array.isArray(saved.dismissed)
    )
      return {
        enabled: saved.enabled,
        dismissed: saved.dismissed.filter((id) => typeof id === 'string'),
      };
    // Keep explanations that returning players already dismissed out of their way.
    return {
      enabled: true,
      dismissed: [
        ...(localStorage.getItem('slashRoll.corebound.tutorial.v2') === 'done'
          ? ['launch']
          : []),
        ...(localStorage.getItem('slashRoll.corebound.portalTutorial.v2') ===
        'done'
          ? ['portals']
          : []),
        ...(localStorage.getItem('slashRoll.corebound.portalTutorial.v1') ===
        'done'
          ? ['portalPair']
          : []),
      ],
    };
  } catch {
    return { enabled: true, dismissed: [] };
  }
};

export const CoreboundHelpProvider = ({ children }) => {
  const [preferences, setPreferences] = useState(readPreferences);
  useEffect(() => {
    try {
      localStorage.setItem(TIPS_STORAGE_KEY, JSON.stringify(preferences));
    } catch {
      // Preferences still work for this session when storage is unavailable.
    }
  }, [preferences]);
  const value = {
    enabled: preferences.enabled,
    isTipVisible: (id) =>
      preferences.enabled && !preferences.dismissed.includes(id),
    dismissTip: (id) =>
      setPreferences((previous) =>
        previous.dismissed.includes(id)
          ? previous
          : {
              ...previous,
              dismissed: [...previous.dismissed, id],
            }
      ),
    setTipsEnabled: (enabled) =>
      setPreferences((previous) => ({ ...previous, enabled })),
    resetTips: () => setPreferences({ enabled: true, dismissed: [] }),
  };
  return <HelpContext.Provider value={value}>{children}</HelpContext.Provider>;
};

const noHelp = {
  enabled: false,
  isTipVisible: () => false,
  dismissTip: () => {},
  setTipsEnabled: () => {},
  resetTips: () => {},
};

export const useCoreboundHelp = () => useContext(HelpContext) || noHelp;
